package com.klantenstop.web.pages.admin.categories.manage

import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.utils.MVI
import org.w3c.files.File

interface ManageCategoryContract : MVI<ManageCategoryContract.State, ManageCategoryContract.Intent, ManageCategoryContract.Effect> {

    data class State(
        val category: Category? = null,
        val isLoading: Boolean = false,
        val isSaving: Boolean = false,
        val isImageLoading: Boolean = false,
        val name: String = "",
        val altText: String = "",
        val highlighted: Boolean = false,
        val description: String = "",
        val logoFile: File? = null,
        val logoUrl: String? = null,
    ) {
        private val nameIsValid = name.isNotBlank()

        private val nameChanged = name != category?.name
        private val altTextChanged = altText != category?.altText
        private val highlightedChanged = highlighted != (category?.highlighted ?: false)
        private val descriptionChanged = description != (category?.description ?: "")
        private val logoChanged = logoFile != null

        val isValid = nameIsValid

        val hasChanged: Boolean
            get() = nameChanged || altTextChanged || highlightedChanged || descriptionChanged || logoChanged
    }

    sealed class Intent {
        data object NavigateBack : Intent()
        data class LoadCategory(val categoryId: String) : Intent()
        data class UpdateName(val name: String) : Intent()
        data class UpdateAltText(val altText: String) : Intent()
        data class UpdateHighlighted(val highlighted: Boolean) : Intent()
        data class UpdateDescription(val description: String) : Intent()
        // Create mode: stage a local file to be sent with SaveCategory
        data class UpdateLogoFile(val file: File) : Intent()
        // Edit mode: upload immediately via dedicated endpoint
        data class UploadImage(val file: File) : Intent()
        data object RemoveImage : Intent()
        data object SaveCategory : Intent()
    }

    sealed class Effect {
        data object NavigateBack : Effect()
        data class ShowError(val message: String) : Effect()
        data class ShowSuccess(val message: String) : Effect()
    }
}

